import { normalizeProductionText } from "./productionSiteAuditUtils";

export const ENTITY_TYPES = ["production"];

function duplicateGroupKey(row) {
  const name = normalizeProductionText(row?.name_production);
  const address = normalizeProductionText(row?.address_production);
  if (!name && !address) {
    return null;
  }
  return `${name}|${address}`;
}

/**
 * Группы площадок с одинаковым name+address у разных company_id.
 */
export function groupCrossCompanyDuplicates(allProductionRows) {
  if (!Array.isArray(allProductionRows) || allProductionRows.length === 0) {
    return [];
  }

  const buckets = new Map();

  for (const row of allProductionRows) {
    const key = duplicateGroupKey(row);
    if (!key) {
      continue;
    }
    let list = buckets.get(key);
    if (!list) {
      list = [];
      buckets.set(key, list);
    }
    list.push(row);
  }

  const groups = [];

  for (const [key, rows] of buckets.entries()) {
    const companyIds = new Set(
      rows.map((r) => Number(r.company_id)).filter((id) => Number.isFinite(id)),
    );
    if (companyIds.size < 2) {
      continue;
    }
    const [namePart, addressPart] = key.split("|");
    groups.push({
      key,
      displayName: namePart,
      displayAddress: addressPart,
      rows: rows.map((r) => ({
        id: r.id,
        company_id: r.company_id,
        name_production: r.name_production,
        address_production: r.address_production,
      })),
      companyCount: companyIds.size,
      recordCount: rows.length,
    });
  }

  groups.sort((a, b) => b.companyCount - a.companyCount || b.recordCount - a.recordCount);

  return groups;
}
